import { render, staticRenderFns } from "./DogCard.vue?vue&type=template&id=53b878e2"
import script from "./DogCard.vue?vue&type=script&lang=ts"
export * from "./DogCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports